import { type ShapeDefinition } from './shape.js';
import { bridge, cathedral, city, stairs } from './shapes/architecture.js';
import { galaxy, lanterns, nautilus, wheat } from './shapes/cosmos.js';
import { butterfly, figure, flock, whale } from './shapes/creatures.js';
import { dunes, mountains, planet, strata } from './shapes/earth.js';
import { flower, jellyfish, tree } from './shapes/life.js';
import { piano, vinyl } from './shapes/music.js';
import { clock, library, room } from './shapes/objects.js';
import { ocean, rain, river } from './shapes/water.js';

/**
 * Everything the visualiser can become. The order here is only the identity of
 * each shape — the director shuffles it, so nothing is ever seen in list order.
 */
export const SHAPES: readonly ShapeDefinition[] = [
  river,
  ocean,
  rain,
  mountains,
  strata,
  dunes,
  planet,
  city,
  cathedral,
  bridge,
  stairs,
  library,
  room,
  clock,
  vinyl,
  piano,
  tree,
  flower,
  jellyfish,
  butterfly,
  flock,
  whale,
  figure,
  galaxy,
  nautilus,
  lanterns,
  wheat,
];
